import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { createContext, forwardRef, useContext, } from 'react';
import { useSupportsHover } from '../../lib/hooks';
import { ProgressiveAsset } from '../ProgressiveAsset';
import * as Styles from './styles';
export const ProductCardContext = createContext({
    isCritical: false,
});
export const Wrapper = forwardRef(function Wrapper({ children, className, isCritical = false, unavailable, unavailableText, ...rest }, ref) {
    return (_jsx(ProductCardContext.Provider, { value: {
            isCritical,
            unavailable,
            unavailableText,
        }, children: _jsx(Styles.Container, { className: className, ref: ref, ...rest, children: children }) }));
});
export const Link = Styles.Link;
export const Media = forwardRef(function Media({ children }, ref) {
    const { unavailable, unavailableText } = useContext(ProductCardContext);
    return (_jsxs(Styles.MediaContainer, { ref: ref, children: [children, _jsx(Styles.Unavailable, { show: unavailable, children: unavailableText ?? 'SOLD OUT' })] }));
});
export const MediaBadge = Styles.BadgeContainer;
export const Overline = forwardRef(function Overline({ color, children, className }, ref) {
    return (_jsx(Styles.OverlineText, { ref: ref, className: className, colorOverride: color, textTransform: 'uppercase', children: children }));
});
export function PrimaryImage({ className, hideOnHover, ...rest }) {
    const { isCritical } = useContext(ProductCardContext);
    return (_jsx(Styles.PrimaryImageContainer, { className: className, hideOnHover: hideOnHover, children: _jsx(ProgressiveAsset.Image, { loading: isCritical ? 'eager' : 'lazy', fetchPriority: isCritical ? 'high' : undefined, ...rest }) }));
}
export function SecondaryImage({ className, ...rest }) {
    const supportsHover = useSupportsHover();
    if (!supportsHover)
        return null;
    return (_jsx(Styles.SecondaryImageContainer, { className: className, children: _jsx(ProgressiveAsset.Image, { loading: 'lazy', fetchPriority: 'low', ...rest }) }));
}
export const Title = Styles.Title;
export const Details = Styles.DetailsContainer;
export const DetailLine = Styles.DetailLine;
//# sourceMappingURL=ProductCard.js.map